import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { useContentGenReviewStore } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/stores';
import { useCreditStatus } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/hooks/useContentGenerate';
import SlSkeleton from 'src/components/BeaconV2Components/SlSkeleton/SlSkeleton';
import { formatMoney } from 'src/utils/stringFormatting';
import IconButton from 'src/components/BeaconV2Components/Generic/IconButton';
import { TooltipIcon } from 'src/components/SvgIcons/SvgIcons';
import InfoModal from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/components/InfoModal';

const StyledBox = ({ children, sx }: { children: React.ReactNode; sx?: SxProps }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        padding: '10px 12px',
        alignItems: 'center',
        gap: '12px',
        width: '172px',
        height: '60px',
        borderRadius: '8px',
        border: `1px solid ${colors.graysSecondary}`,
        background: colors.contentGenBackground,
        ...sx
      }}
    >
      {children}
    </Box>
  );
};

export const RetailerSkuCreditBalanceHeader = () => {
  const { contentGenItemsToReview, getCurrentContentGenItemIndex } = useContentGenReviewStore();
  const { creditBalance, isLoading: isLoadingCredits, isError: creditError } = useCreditStatus();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Flex flexDirection="row" gap={19}>
      <StyledBox sx={{ width: '157px' }}>
        <Flex flexDirection="column" gap={0}>
          <Flex alignItems="center" gap={8}>
            <Text
              variant="body2"
              sx={{
                color: colors.grey,
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: '0.96px',
                whiteSpace: 'nowrap'
              }}
            >
              CREDIT BALANCE
            </Text>
            <IconButton
              onClick={() => setIsOpen(true)}
              sxProps={{ padding: '0', '&:hover': { backgroundColor: 'transparent' } }}
            >
              <TooltipIcon width={16} height={16} />
            </IconButton>
          </Flex>
          {isLoadingCredits ? (
            <SlSkeleton variant="rectangular" width={60} height={16} sx={{ borderRadius: '2px' }} />
          ) : (
            <Text
              variant="body1"
              sx={{
                color: creditError ? colors.red : colors.darkBlue,
                fontSize: '18px',
                fontStyle: 'normal',
                fontWeight: 500
              }}
            >
              {creditError ? 'Error' : formatMoney(creditBalance, '')}
            </Text>
          )}
        </Flex>
      </StyledBox>

      {contentGenItemsToReview.length > 1 && (
        <StyledBox>
          <Flex flexDirection="column" gap={4}>
            <Text
              variant="body2"
              sx={{
                color: colors.grey,
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 500,
                textTransform: 'uppercase'
              }}
            >
              CONTENT TO REVIEW
            </Text>
            <Text
              variant="body1"
              sx={{
                color: colors.darkBlue,
                fontSize: '18px',
                fontStyle: 'normal',
                fontWeight: 500,
                textTransform: 'uppercase'
              }}
            >{`${getCurrentContentGenItemIndex() + 1} of ${contentGenItemsToReview.length}`}</Text>
          </Flex>
        </StyledBox>
      )}

      <InfoModal isOpen={isOpen} setIsOpen={setIsOpen} mode="Generations" />
    </Flex>
  );
};
